'use strict';

import SpotHeroBase from 'spothero-base';
import moment from 'moment'; // eslint-disable-line no-unused-vars
import SHCommonModules from 'sh-common-modules'; // eslint-disable-line no-unused-vars

module.exports = window.SpotHero = {
    init() {
        SpotHeroBase.init();
    }
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/modules/common/spothero.js